import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-69c1f6ba"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "form"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("h5", {
    class: "title"
  }, "选手登录信息", -1);
});
var _hoisted_3 = /*#__PURE__*/_createTextVNode(" 登录 ");
import { computed, reactive, ref, toRefs } from 'vue';
import { UserService } from '@/services/user.service';
import { DaoService } from '@/services/dao.service';
import { useService } from '@kaokei/use-vue-service';
import { setToken } from '@/utils';
import { useRoute, useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  props: {
    carNoInfo: {
      type: Object,
      required: true,
      default: function () {
        return {
          placeholder: '',
          ruleMessage: ''
        };
      }
    },
    nameInfo: {
      type: Object,
      required: true,
      default: function () {
        return {
          placeholder: '',
          ruleMessage: ''
        };
      }
    },
    contestType: {
      type: String,
      required: true,
      default: ''
    },
    contestYear: {
      type: String,
      required: true,
      default: ''
    },
    theme: {
      type: String,
      required: true,
      default: ''
    }
  },
  setup: function (__props) {
    var props = __props;
    var _a = toRefs(props),
      carNoInfo = _a.carNoInfo,
      contestType = _a.contestType,
      contestYear = _a.contestYear,
      nameInfo = _a.nameInfo;
    var route = useRoute();
    var router = useRouter();
    var userService = useService(UserService);
    var daoService = useService(DaoService);
    var formState = reactive({
      name: '',
      carNo: ''
    });
    var formRules = computed(function () {
      return {
        name: [{
          required: true,
          message: nameInfo.value.ruleMessage,
          trigger: 'blur'
        }],
        carNo: [{
          required: true,
          message: carNoInfo.value.ruleMessage,
          trigger: 'blur'
        }]
      };
    });
    var formRef = ref();
    var onSubmit = function () {
      formRef.value.validate().then(function () {
        var serviceName = contestType.value === 'aild' ? 'loginByCarNoAndName' : 'loginByMobileAndCarNo';
        daoService[serviceName]({
          carNo: formState.carNo,
          mobile: contestType.value === 'icc' ? formState.name : undefined,
          name: contestType.value === 'aild' ? formState.name : undefined,
          activityInfo: "".concat(contestType.value, "-").concat(contestYear.value)
        }).then(function (res) {
          setToken(res.token);
          return userService.initUserInfo().then(function () {
            var _a;
            router.push({
              name: (_a = route.meta) === null || _a === void 0 ? void 0 : _a.entryUrlName
            });
          });
        });
      });
    };
    return function (_ctx, _cache) {
      var _component_a_input = _resolveComponent("a-input");
      var _component_a_form_item = _resolveComponent("a-form-item");
      var _component_a_button = _resolveComponent("a-button");
      var _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass("contest-form ".concat(__props.theme && "contest-form-".concat(__props.theme)))
      }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_a_form, {
        ref: function (_value, _refs) {
          _refs['formRef'] = _value;
          formRef.value = _value;
        },
        rules: _unref(formRules),
        model: _unref(formState),
        "label-col": {
          span: 5
        },
        "wrapper-col": {
          span: 24
        },
        hideRequiredMark: true
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_form_item, {
            label: "",
            colns: false,
            name: "name",
            class: "input-item"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_input, {
                maxlength: 50,
                value: _unref(formState).name,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(formState).name = $event;
                }),
                valueModifiers: {
                  trim: true
                },
                placeholder: _unref(nameInfo).placeholder
              }, null, 8, ["value", "placeholder"])];
            }),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "",
            colns: false,
            name: "carNo",
            class: "input-item"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_input, {
                maxlength: 50,
                value: _unref(formState).carNo,
                "onUpdate:value": _cache[1] || (_cache[1] = function ($event) {
                  return _unref(formState).carNo = $event;
                }),
                valueModifiers: {
                  trim: true
                },
                placeholder: _unref(carNoInfo).placeholder
              }, null, 8, ["value", "placeholder"])];
            }),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_button, {
                class: "form-login",
                type: "primary",
                onClick: _withModifiers(onSubmit, ["prevent"])
              }, {
                default: _withCtx(function () {
                  return [_hoisted_3];
                }),
                _: 1
              }, 8, ["onClick"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["rules", "model"])])], 2);
    };
  }
});